// API Configuration
// For local development, it uses production API by default
// To use local API, set VITE_API_URL=http://localhost:5001 in your .env file
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.munger.ai';

// For production builds, you can override this with:
// VITE_API_URL=https://api.munger.ai npm run build

export const getApiUrl = (endpoint: string) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
}; 